import * as React from 'react';

import { BaseField, BaseFieldProps, FieldConverter } from '../BaseField';

export interface FieldTextProps extends Omit<BaseFieldProps<string | null>, 'converter'> {
    trim?: boolean;
}

export const FieldText = React.forwardRef<HTMLDivElement, FieldTextProps>((props, ref) => {
    const { trim = false, ...restProps } = props;
    const converter = React.useMemo(() => createTextConverter({ trim }), [trim]);

    return <BaseField ref={ref} converter={converter} {...restProps} />;
});

export function createTextConverter(options: { trim: boolean }): FieldConverter<string | null> {
    const { trim } = options;

    return {
        parseValue: (text) => {
            const processedText = trim ? text.trim() : text;

            if (processedText === '') {
                return { ok: true, value: null };
            }

            return { ok: true, value: processedText };
        },
        formatValue: (value) => {
            if (value === null) {
                return '';
            }
            return value;
        },
    };
}
